// React, RTK
import React, { useState } from 'react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { useAppSelector } from '../../app/hooks';
// Mui
import Link from '@mui/material/Link';
import { Link as RLink } from "react-router-dom";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import Dialog, { DialogProps } from '@mui/material/Dialog';
// Protos
import { SerializedError } from '../../util/types';
import { useTicketViewQuery, TicketItemsResponse } from '../../api/ticket';
import { selectTicket } from './ticketSlice';

interface QueryProps {
	id: string | null;
	data: TicketItemsResponse;
	isLoading: boolean;
	isFetching: boolean;
	isSuccess: boolean;
	isError: boolean;
	error: FetchBaseQueryError | SerializedError | undefined;
};


export function ToolBar({id, data, isLoading, isFetching, isSuccess, isError, error}: QueryProps) {
	const sx = {
		backgroundColor: '#eeeeee',
		display: 'flex',
		height: 45,
		width: '100%',
		paddingLeft: 6,
		paddingRight: 10,
		alignItems: 'center',
	};
	const sxleft = {
		flexGrow: 1,
		//backgroundColor: 'green',
	};
	const sxright = {
		flexGrow: 4,
		//backgroundColor: 'yellow',
	};
	const ticket = useAppSelector(selectTicket(id ? id : ""));
	/*
	const [open, setOpen] = React.useState(false);
	const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');

	const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
		setOpen(true);
		setScroll(scrollType);
	};

	const handleClose = () => {
		console.log('is this closing happening?');
		setOpen(false);
	};

	const descriptionElementRef = React.useRef<HTMLElement>(null);
	React.useEffect(() => {
		if (open) {
			const { current: descriptionElement } = descriptionElementRef;
			if (descriptionElement !== null) {
				descriptionElement.focus();
			}
		}
	}, [open]);
	// */

	const idLinkString = id ? "/" + id : "";
	const idParentLinkString = ticket && ticket.parent_id ? "/" + ticket.parent_id : "";
	return (
		<Box position="fixed" sx={sx}>
			<Box sx={sxleft}>
                {/*
				<Typography>Tickets</Typography>
                */}
			</Box>
			<Box sx={sxright}>
				<Link component={RLink} to={"/ticket/edit"}>
					<Button
						variant="outlined"
						startIcon={<AddIcon />}
						size="small"
					>
						New
					</Button>
				</Link>
				<Link component={RLink} to={"/ticket/edit" + idLinkString}>
					<Button
						variant="outlined"
						startIcon={<AddIcon />}
						size="small"
					>
						Edit
					</Button>
				</Link>
				{ticket &&
				<Link component={RLink} to={"/ticket/view" + idParentLinkString}>
					<Button
						variant="outlined"
						startIcon={<AddIcon />}
						size="small"
					>
						Parent
					</Button>
				</Link>
				}
			</Box>
		</Box>
	)
}
